import React from 'react';
import {Tabs} from "./navigation/Tabs";

export function CourseDashboardHeader({name, courseId, token}) {

    function getSubToken(token, tokenType) {
        return token.subTokens.find(element => element.type === tokenType);
    }

    function buildTabs() {
        const tabs = [];
        const quizToken = getSubToken(token , "QUIZ")
        const labToken = getSubToken(token , "LAB_COURSE")
        const evaluationToken = getSubToken(token , "PERFORMANCE")

        tabs.push({text: "Kurs", url:"kurs"})

        if(quizToken) {
            tabs.push({text: "Quiz", url:"quiz"})
        }

        if(labToken) {
            tabs.push({text: "Labkurs", url:"lab"})
        }

        if(evaluationToken) {
            tabs.push({text: "Evaluering", url:"evaluering"})
        }

        tabs.push({text:"Begrep", url:"begrep"})
        tabs.push({text:"Abonnement", url:"abonnement"})

        return tabs;
    }

    function getCurrentTab() {
        const path = window.location.pathname;
        return path.substring(path.lastIndexOf("/")+1)
    }

    const tabs = buildTabs()

    return (
        <div className={"p-0 mb-3 ps-3 pt-4 "}>
            <h4 className={"border-bottom text-center pb-3 fw-bold"}>{name}</h4>


            <Tabs items={tabs} currentTab={getCurrentTab()}/>
        </div>
    );

}